import {INIT_INDEX} from 'util/constants';
import {readColors} from 'config/highcharts';

import 'style/_colors.scss';

const colors = readColors();

export const getColors = num => {
    if (colors.length < num) {
        colors.push.apply(colors, colors);

        return getColors(num);
    }

    return colors.slice(INIT_INDEX, num);
};

const WARNING = '#53B7E8';
const MINOR = '#043776';
const MAJOR = '#FFC814';
const CRITICAL = '#F68C1F';

const STATES = {
    CRITICAL,
    WARNING,
    MINOR,
    MAJOR
};


/* eslint-disable no-magic-numbers */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable max-params */

export const getStackedBarChartBasicConfig = () => ({
    chart: {
        type:   'column',
        height: 230
    },
    title: {
        text: ''
    },
    xAxis: {
        categories:    [],
        gridLineWidth: 0
    },
    yAxis: {
        min:   0,
        title: {
            text: ''
        },
        gridLineWidth:  0,
        reversedStacks: false
    },
    tooltip: {
        pointFormat: '<span>{series.name}</span>: <b>{point.y}</b> ({point.percentage:.0f}%)<br/>',
        shared:      true
    },
    plotOptions: {
        column: {
            stacking: 'normal'
        }
    },
    colors: [STATES.WARNING, STATES.MINOR, STATES.MAJOR, STATES.CRITICAL]
});
/*
export const getChartEventsBySeverity = () => ({
    chart: {
        type: 'pie'

    },
    title: {
        text:          '1344',
        verticalAlign: 'middle',
        y:             10,
        floating:      true
    },
    plotOptions: {
        pie: {
            fillOpacity: 0.4,
            dataLabels:  {
                enabled: false,
                format:  '{point.percentage:.1f} %'
            },
            showInLegend: true
        }
    },
    colors:  [STATES.WARNING, STATES.MINOR, STATES.MAJOR, STATES.DANGER],
    tooltip: {
        headerFormat: ' ',
        pointFormat:  '<span>{point.name}</span>: <b>${point.y:.2f}</b><br/>'
    }
});*/

export const getChartCIsByCIClass = series => ({
    chart: {
        type: 'pie'
    },
    title: {
        text: ''
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                format:  '{point.name}: {point.y}'
            }
        },
        showInLegend: true
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:  '<span style="color:{point.color}">Class: {point.name}</span>: <b>{point.y}</b> CIs <br/>'
    },

    series
});

export const getChartActiveClosed = series => ({
    chart: {
        type: 'pie'
    },
    title: {
        text: ''
    },
    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                format:  '{point.name}: {point.y}'
            }
        },
        showInLegend: true
    },
    tooltip: {
        headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        pointFormat:  '<span style="color:{point.color}">Class: {point.name}</span>: <b>{point.percentage:.1f}%</b>'
    },

    series
});


/* eslint-enable */



// WEBPACK FOOTER //
// ./src/containers/monitoring/config/charts.js